import { makeStyles } from '@material-ui/core'
import { colors } from 'constants/index'

export const useStyles = makeStyles({
  link: {
    fontSize: 15,
    fontWeight: 'normal',
    textDecoration: 'none',
    color: colors.BASIC.COLOR['100'],
    '&:hover': {
      fontSize: 15,
      fontWeight: 'normal',
      color: colors.ADDITIONAL.COLOR['50'],
    },
  },
  boldLink: {
    fontWeight: 500,
  },
  mainFolderIcon: {
    marginRight: 12,
  },
  secondaryIcon: {
    marginRight: 4,
  },
  input: {
    height: 32,
  },
  cell: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
  },
  tableCell: {
    paddingLeft: 0,
  },
  numbers: {
    fontSize: 15,
    fontWeight: 'normal',
    color: colors.BASIC.COLOR['100'],
  },
  inactiveNumber: {
    color: colors.BASIC.COLOR['50'],
  },
  fileInfoContainer: {
    marginLeft: 16,
    display: 'flex',
  },
  icon: {
    marginRight: 8,
  },
  error: {
    color: colors.ERROR,
    padding: '5px 0',
    textAlign: 'left',
  },
  tableCellLog: {
    paddingLeft: 0,
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: 13,
    fontWeight: 400,
    color: colors.BASIC.COLOR[100],
  },
  action: {
    fontWeight: 500,
  },
  thumbnail: {
    maxWidth: 32,
    maxHeight: 32,
    marginRight: 8,
  },
  selectedRow: {
    backgroundColor: colors.ADDITIONAL.TRANSPARENT['8'],
  },
  shareButton: {
    width: 16,
    height: 16,
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    cursor: 'pointer',
  },
  shareButtonRotated: {
    transform: 'rotate(180deg)',
  },
  tooltip: {
    backgroundColor: colors.BASIC.COLOR[80],
    color: colors.WHITE,
    fontSize: 13,
    fontWeight: 'normal',
  },
  providersContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    cursor: 'pointer',
  },
  providerAvatarWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  providerAvatar: {
    width: 24,
    height: 24,
    fontSize: 9.75,
    fontWeight: 400,
    backgroundColor: colors.BASIC.COLOR[80],
    color: colors.WHITE,
    border: `2px solid ${colors.WHITE}`,
  },
  providerAvatarOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(53, 87, 43, 1)',
    borderRadius: '50%',
    border: `2px solid ${colors.WHITE}`,
  },
  providerAvatarCount: {
    fontSize: 9.75,
    fontWeight: 400,
    lineHeight: '13.5px',
    color: colors.WHITE,
    textTransform: 'uppercase',
  },
})
